import { render, staticRenderFns } from "./yc-farming.vue?vue&type=template&id=4876ccea&scoped=true&"
import script from "./yc-farming.vue?vue&type=script&lang=js&"
export * from "./yc-farming.vue?vue&type=script&lang=js&"
import style0 from "./yc-farming.vue?vue&type=style&index=0&id=4876ccea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4876ccea",
  null
  
)

export default component.exports